export default html => ({ __html: html });
